import { render, staticRenderFns } from "./minikj_error.vue?vue&type=template&id=3e154342&scoped=true&"
import script from "./minikj_error.vue?vue&type=script&lang=js&"
export * from "./minikj_error.vue?vue&type=script&lang=js&"
import style0 from "./minikj_error.vue?vue&type=style&index=0&id=3e154342&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e154342",
  null
  
)

export default component.exports